import { Formik } from 'formik';
import useAxios from 'hooks/useAxios';
import React, { useState } from 'react';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, CardBody, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import FormikInputField from 'components/common/Fields/FormikInputField';
import { cloneDeep } from 'lodash';
import { ModuleAccess } from 'utils/moduleaccess';
import save from "assets/icon/save.svg";
import reseticon from "assets/icon/reset.svg";
import { Field, } from 'formik';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import { toast } from 'react-toastify';
import cancelIcon from "assets/icon/cancel.svg";

let hasDatePopupOpen = false;
let addPatientData = {};

const AddPatient = (props) => {
    const { orgId, key, fetchAccumulatorTable, manvalPharmacy } = props;

    const API = useAxios();
    const patientStatusdata = [
        { id: "Y", label: "IN" },
        { id: "N", label: "OUT" },
    ]
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const [collapseSider, setcollapseSider] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [patientcodeerr, setPatientCodeError] = useState('');
    const [patientdescerr, setPatientDescError] = useState('');
    const [patientstatuserr, setPatientStatusError] = useState("");
    const [dateerror, setDateError] = useState("");
    const [patientcode, setPatientCode] = useState('');
    const [patientdesc, setPatientDesc] = useState("");
    const [active, setActive] = useState(true);
    const [totalRecords, SetTotalRecords] = useState("");
    const [errorMessage, setErrorMessage] = useState('');

    const [openPharmacy, setOpenPharmacy] = useState(false);
    const initialValues = {
        patienttypecode: '',
        Patientdesc: '',
        patientstatus: {},
        effectivedate: '',
    };
    const [selectedPatientStatus, setSelectedPatientStatus] = useState("");

    const handelpatientcode = ({ target: { value } }) => {
        setPatientCode(value)
        if (value.length > 0) {
            setPatientCodeError("")
        }
        if (value.length == 0) {
            setPatientCodeError("Patient Type Code is a required field")
        }
        addPatientData.patientcode = value
    }
    const handelPatientdesc = ({ target: { value } }) => {
        setPatientDesc(value)
        if (value.length > 0) {
            setPatientDescError("")
        }
        addPatientData.patientdesc = value
    }
    const handelpatientStatus = (e, setFieldValue,) => {
        const { value } = e.target;
        setFieldValue('patientstatus', value);
        if (value.length > 0) {
            setPatientStatusError("")
        }
        setSelectedPatientStatus(value)
        addPatientData.patientstatus = value
    }
    const handelActive = (event) => {
        setActive(event.target.checked)
    }
    const handleSubmit = async () => {
        debugger;
        let checkedvalue = ""
        if (patientcode.length == 0) {
            setPatientCodeError("Patient Type Code is a required field")
        }
        if (patientdesc.length == 0) {
            setPatientDescError("Patient Type Description is a required field")
        }
        if (selectedPatientStatus.length == 0) {
            setPatientStatusError("Patient Status is a required field")
        }

        if (selectedPatientStatus.length > 0) {
            setPatientStatusError("")
        }
        if (active == true) {
            checkedvalue = "N"
        }
        if (active == false) {
            checkedvalue = "Y"
        }
        let AddPatientEntity = []
        let payload = {};
        payload.PatientTypeCode = patientcode,
            payload.PatientTypeDescription = patientdesc,
            payload.PatientStatus = selectedPatientStatus
        payload.InactiveFlag = checkedvalue
        AddPatientEntity.push(payload)
        if (patientcode.length > 0 && patientdesc.length > 0 && selectedPatientStatus) {
            try {
                const { data } = await API.post(`SBTenant/${orgId.tenantID}/Configuration/AddPatient`, { AddPatientEntity }, { hasDefaultURL: true });

                if (data) {
                    if (data[0].success === false) {

                        setErrorMessage("Patient type already exists");
                    }
                    else {
                        toast.success('Patient Added Successfully');
                        fetchAccumulatorTable();
                        manvalPharmacy()
                        handelCancel()
                    }
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        }

    }
    const handelCancel = () => {
        setErrorMessage("");
        setPatientCode('');
        setPatientDesc("");
        setSelectedPatientStatus("");
        setPatientCodeError("");
        setPatientDescError("");
        setPatientStatusError("");
    }
    const hasPermission = (code) => {
        return ModuleAccess("CON", code);
    };
    return (
        <div>
            <div className={"" ? "mb-0" : "mb-3"}>

                <Card hidden={""} className="border-0 shadow-top ">
                    <CardBody>
                        {/* <div className="py-2 text-center">
<span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
    <FontAwesomeIcon icon={collIcon} className="fa-fw" />
</span>

</div> */}
                        <Formik
                            initialValues={initialValues}
                            onSubmit={handleSubmit}
                            enableReinitialize={true}
                            // enableReinitialize={true}
                            children={(props) => {
                                const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                                return (
                                    <div hidden={collapseSider}>
                                        <h5 className='f-16 text-primary font-weight-700'>
                                            Add Patient Type
                                        </h5>
                                        <div >
                                            <Row sm={5} className='d-flex' style={{}}>

                                                <Col md={3} lg={3} sm={6} xs={6}  >
                                                    {' '}
                                                    <FormGroup>
                                                        <Label for='patienttypecode'>Patient Type Code</Label>
                                                        <Input
                                                            id='patienttypecode'
                                                            name='patienttypecode'
                                                            type='text'
                                                            value={patientcode}
                                                            className="required"
                                                            placeholder="Enter Patient Type Code"
                                                            autoComplete='off'
                                                            onChange={handelpatientcode}
                                                            component={FormikInputField}
                                                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                                        />

                                                        {patientcodeerr && <div className="text-danger font-size-12">{patientcodeerr}</div>}
                                                    </FormGroup>
                                                </Col>

                                                <Col md={3} lg={3} sm={6} xs={6}  >
                                                    {' '}
                                                    <FormGroup>
                                                        <Label for='Patientdesc'>Patient Type Description</Label>
                                                        <Input
                                                            id='Patientdesc'
                                                            name='Patientdesc'
                                                            type='text'
                                                            value={patientdesc}
                                                            className="required"
                                                            placeholder="Enter Patient Type Description"
                                                            autoComplete='off'
                                                            component={FormikInputField}
                                                            onChange={handelPatientdesc}
                                                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                                        />
                                                        {patientdescerr && <div className="text-danger font-size-12">{patientdescerr}</div>}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3} lg={3} sm={6} xs={6}  >
                                                    {' '}
                                                    <FormGroup>
                                                        <Label for='Patientstatus'>Patient Status</Label>
                                                        <Field
                                                            // id='patientstatus'
                                                            name='patientstatus'
                                                            type='text'
                                                            placeholder="Enter Patient Type Description"
                                                            autoComplete='off'
                                                            defaultoption='--Select--'
                                                            className="required"
                                                            options={patientStatusdata}
                                                            value={selectedPatientStatus}
                                                            component={FormikSelectField}
                                                            onChange={(e) => handelpatientStatus(e, setFieldValue)}
                                                            keys={{
                                                                id: 'id',
                                                                label: 'label',
                                                            }}
                                                        />
                                                        {patientstatuserr && <div className="text-danger font-size-12">{patientstatuserr}</div>}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3} lg={3} sm={6} xs={6} style={{ marginTop: "32px" }}  >
                                                    {' '}
                                                    <FormGroup>
                                                        <Label for='effectivedate'>Active
                                                        </Label>
                                                        <Input
                                                            type="checkbox"
                                                            style={{ marginLeft: "10px" }}
                                                            id="active"
                                                            name="active"
                                                            checked={active}
                                                            onChange={(event) => {
                                                                handelActive(event)
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div hidden={""}>
                                            <Row md="auto" style={{ justifyContent: "flex-end" }}>
                                                {/* <Col sm={8}>
                        {errorMessage ? (
                            <div
                                style={{
                                    display: "inline-block",
                                    backgroundColor: "#ffe6e6",
                                    marginLeft: "10px",
                                    //padding: "5px"
                                }}
                                className="text-danger f-12"
                            >
                                {errorMessage}
                            </div>
                        ) : null}
                    </Col> */}
                                                <Col sm={2} className="d-flex"
                                                    style={{ justifyContent: "flex-end" }}
                                                >
                                                    <Label>{""}</Label>
                                                    <Button
                                                        // hidden={isAddPermission}
                                                        // disabled={isSubmitting}
                                                        color="primary"
                                                        className="search"
                                                        onClick={handleSubmit}
                                                        // disabled={!coveredEntityid}
                                                        hidden={!hasPermission("ED")}
                                                    >
                                                        <span className="right_5">
                                                            <img src={save} alt="" />
                                                        </span> Save
                                                    </Button>
                                                    <Button

                                                        color="primary"
                                                        className="reset"
                                                        onClick={manvalPharmacy}
                                                    >
                                                        <span className="right_5">
                                                            <img src={cancelIcon} alt="" />
                                                        </span> Cancel
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={8}>
                                                    {errorMessage ? (
                                                        <div
                                                            style={{
                                                                display: "inline-block",
                                                                backgroundColor: "#ffe6e6",
                                                                // marginLeft: "10px",
                                                                //padding: "5px"
                                                            }}
                                                            className="text-danger f-12"
                                                        >
                                                            {errorMessage}
                                                        </div>
                                                    ) : null}
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                );
                            }}></Formik>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

export default AddPatient